<template lang="pug">
shListData(title="Mensajes de Regalo" resolver="giftMessages" keyData="order" component="shGiftMessage")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'GiftMessages',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/giftMessage/GiftMessages.vue